<template>
  <span>
    <v-toolbar dense
               fixed>
      <v-btn router
             flat
             to="/viewfreight"
             class="teal--text darken-2">Kangaruu</v-btn>
      <v-spacer></v-spacer>

      <v-btn class="teal--text darken-2"
             small
             router
             flat
             icon
             v-on:click="logout">
        <v-icon>exit_to_app</v-icon>
      </v-btn>
    </v-toolbar>

    <v-layout>
      <v-flex xs12>
        <v-card>
          <v-toolbar color="teal"
                     dark>

            <v-toolbar-title>My Brokers</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon
                   @click.native.stop="inviteBrokers = true">
              <v-icon>email</v-icon>
            </v-btn>
            <v-btn icon
                   @click.native.stop="updateBrokers">
              <v-icon>search</v-icon>
            </v-btn>
            <v-btn small
                   flat
                   icon
                   v-on:click.native="$router.push({ name: 'viewfreight' })"
                   color="white">
              <v-icon>keyboard_backspace</v-icon>
            </v-btn>
          </v-toolbar>

          <v-dialog v-model="showBrokers"
                    max-width="400">
            <v-card>
              <v-card-title>
                <span class="headline">Add Brokers</span>
              </v-card-title>
              <v-data-table :items="newBrokers"
                            v-model="selectedBroker"
                            :headers="headers"
                            no-data-text="No new brokers available"
                            item-key="id"
                            select-all
                            class="elevation-1">

                <template slot="headerCell"
                          slot-scope="props">
                  <v-tooltip bottom>
                    <span slot="activator">
                      {{ props.header.text }}
                    </span>
                    <span>
                      {{ props.header.text }}
                    </span>
                  </v-tooltip>
                </template>
                <template slot="items"
                          slot-scope="props">
                  <td>
                    <v-checkbox primary
                                hide-details
                                v-model="props.selected">
                    </v-checkbox>
                  </td>
                  <td>{{ props.item.username }}</td>
                  <td>{{ props.item.company }}</td>

                </template>
              </v-data-table>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1"
                       flat
                       @click.native="addBrokers()">Ok</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-dialog v-model="inviteBrokers"
                    max-width="400">
            <v-card>
              <v-card-title>
                <span class="headline">Invite Brokers</span>
              </v-card-title>
              <v-card-text>
                <v-container grid-list-md>
                  <v-layout wrap>
                    <v-flex xs12
                            sm6
                            md4>
                      <v-text-field v-model="firstName"
                                    label="First Name"
                                    required></v-text-field>
                    </v-flex>

                    <v-flex xs12
                            sm6
                            md4>
                      <v-text-field v-model="lastName"
                                    label="Last Name"
                                    required></v-text-field>
                    </v-flex>
                    <v-flex xs12>
                      <v-text-field v-model="email"
                                    :rules="emailRules"
                                    label="Email"
                                    required></v-text-field>
                    </v-flex>

                  </v-layout>
                </v-container>
                <small>*indicates required field</small>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1"
                       flat
                       @click.native="inviteBrokers = false">Cancel</v-btn>
                <v-btn color="blue darken-1"
                       flat
                       @click.native="sendEmail()">Send</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-layout row
                    wrap
                    v-if="!Object.keys(user).length">
            <v-flex>
              <v-card>
                <v-card-text class="blue--text darken-4">
                  This is where you manage your brokers. Invite your Brokers to Kangaruu
                  <v-icon>email</v-icon> or add them from the global list
                  <v-icon>search</v-icon> using the toolbar.
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>

          <v-list two-line>
            <template v-for="(broker, key, index) in user.brokers">
              <v-list-tile avatar
                           ripple
                           @click="toggle(index)"
                           :key="index">
                <v-list-tile-content>
                  <v-list-tile-title>
                    <broker-name :brokerID="key"></broker-name>
                  </v-list-tile-title>
                  <v-list-tile-sub-title class="text--primary"></v-list-tile-sub-title>
                  <v-list-tile-sub-title>
                  </v-list-tile-sub-title>
                </v-list-tile-content>
                <v-list-tile-action>
                  <v-list-tile-action-text>
                    <v-btn icon
                           ripple
                           @click.native="deleteBroker(key)">
                      <v-icon color="grey lighten-1">delete</v-icon>
                    </v-btn>
                  </v-list-tile-action-text>
                </v-list-tile-action>
              </v-list-tile>
            </template>
            <v-divider></v-divider>
          </v-list>
        </v-card>
      </v-flex>
      <v-snackbar v-if="snackbar == true"
                  :timeout="4000"
                  v-model="snackbar">
        Email has been sent!
        <v-btn dark
               flat
               @click.native="snackbar = false">Close</v-btn>
      </v-snackbar>

    </v-layout>

  </span>

</template>


<script>
import db from './fireBaseInit'
import brokerName from './BrokerName'
import Firebase from 'firebase'

export default {
  components: { brokerName },

  name: 'brokers',
  data () {
    return {
      user: {},
      selected: [],
      selectedBroker: [],
      newBrokers: [],
      inviteBrokers: false,
      showBrokers: false,
      brokers: [],
      search: '',
      snackbar: false,
      email: '',
      firstName: '',
      lastName: '',
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'E-mail must be valid'],
      headers: [
        {
          text: 'Brokers',
          align: 'left',
          sortable: true,
          value: false
        },
        { text: 'Company', value: false }
      ]
    }
  },
  firestore () {
    return {
      brokers: db.collection('users').where('isBroker', '==', true)
    }
  },
  mounted: function () {
    this.$bind('user', db.collection('users').doc(Firebase.auth().currentUser.uid))
      .then((doc) => {
        // all good
      })
      .catch((error) => {
        console.log('error in loading: ', error)
      })
  },
  computed: {
  },
  watch: {
    user: function () {
      console.log('here I am')
      return null
    }
  },
  methods: {
    logout: function () {
      Firebase.auth().signOut().then(() => {
        this.$router.replace('/')
      })
    },
    toggle (index) {
      const i = this.selected.indexOf(index)

      if (i > -1) {
        this.selected.splice(i, 1)
      } else {
        this.selected.push(index)
      }
    },
    guid () {
      function _p8 (s) {
        var p = (Math.random().toString(16) + '00000000').substr(2, 6)
        return s ? '-' + p.substr(0, 4) + '-' + p.substr(4, 4) : p
      }
      return _p8()
    },
    sendEmail: function () {
      this.inviteBrokers = false
      // var user = Firebase.auth().currentUser
      let mail = {}
      mail['firstName'] = this.firstName
      mail['lastName'] = this.lastName
      mail['email'] = this.email
      mail['senderEmail'] = this.user.email
      mail['senderName'] = this.user.username
      mail['senderLastName'] = this.user.lastname
      mail['senderCompany'] = this.user.company
      mail['senderRef'] = this.guid()
      mail['senderID'] = Firebase.auth().currentUser.uid
      db.collection('mail').add(mail).then((snap) => {
        this.snackbar = true
      })
    },
    addBrokers: function () {
      this.showBrokers = false
      if (this.selectedBroker.length > 0) {
        let brokerList = {}
        for (var i = 0; i < this.selectedBroker.length; i++) {
          brokerList[`${this.selectedBroker[i].id}`] = true
        }
        for (var key in this.user.brokers) {
          brokerList[key] = true
        }
        var brokerObj = { brokers: brokerList }
        db.collection('users').doc(Firebase.auth().currentUser.uid).update(brokerObj)
      }
    },
    updateBrokers: function () {
      this.newBrokers = this.brokers.slice()
      for (var i = 0; i < this.newBrokers.length; i++) {
        for (var key in this.user.brokers) {
          console.log(key)
          if (this.newBrokers[i].id === key) {
            this.newBrokers.splice(i, 1)
          }
        }
      }
      this.showBrokers = true
    },
    deleteBroker: function (deleteKey) {
      let brokerList = {}
      for (var key in this.user.brokers) {
        console.log(key, deleteKey)
        if (key !== deleteKey) {
          brokerList[key] = true
        }
      }
      var brokerObj = { brokers: brokerList }
      db.collection('users').doc(Firebase.auth().currentUser.uid).update(brokerObj)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Brokers.vue